// Agents: board: the routes and the sidebar rows of `wealth.ai.agents.board` (ADR-0027).
import type { AgentTask } from '@septima/contract';
import { useAgent } from '@/contexts/AgentContext';
import { defineWebFeature } from '@/features/kit';

import { agentReviewItems } from '@/pages/desk/actions/worklist';

export default defineWebFeature({
    id: 'wealth.ai.agents.board',
    routes: [
        { frontend: 'desk', path: 'agents', lazy: () => import('@/pages/desk/agents/page') },
        {
            frontend: 'ops',
            path: 'agents',
            lazy: () => import('@/components/agent/AgentKanbanBoard'),
        },
        {
            frontend: 'comply',
            path: 'agents',
            lazy: () => import('@/components/agent/AgentKanbanBoard'),
        },
        {
            frontend: 'view',
            path: 'agents',
            lazy: () => import('@/components/agent/AgentKanbanBoard'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'agents',
            label: 'Agents',
            href: '/comply/agents',
            icon: 'Bot',
            group: 'automation',
            order: 710,
        },
        // --- Automation ---
        {
            frontend: 'desk',
            key: 'agents',
            label: 'Agents',
            href: '/desk/agents',
            icon: 'Bot',
            group: 'automation',
            order: 510,
        },
        {
            frontend: 'ops',
            key: 'agents',
            label: 'Agents',
            href: '/ops/agents',
            icon: 'Bot',
            group: 'automation',
            order: 610,
        },
        {
            frontend: 'view',
            key: 'agents',
            label: 'Agents',
            href: '/view/agents',
            icon: 'Bot',
            group: 'automation',
            order: 610,
        },
    ],
    slots: {
        'desk.worklist.sources': [
            {
                // The agent artefacts that wait for a review. The queue lives
                // in the agent context, so the source reads it with a hook.
                key: 'agent-reviews',
                order: 40,
                useInput: () => useAgent().reviewQueue,
                select: (input) => ({
                    items: agentReviewItems((input as AgentTask[] | undefined) ?? []),
                    tile: {
                        label: 'Client Tasks',
                        severity: 'red',
                        to: '/desk/agents?column=review_required',
                        ariaLabel: 'Client Tasks: open the review queue',
                    },
                }),
            },
        ],
    },
});
